"use client";

import Link from "next/link";
import colors from "../../styles/colors";
import Logo from "../../public/Link_margin.png";
import { FaPhoneAlt } from "react-icons/fa";
import { IoMdSearch } from "react-icons/io";
import { useState, useRef, useEffect } from "react";
import Image from "next/image";
import { useRouter } from "next/navigation";
import { useFilter } from "../context/ProductContext";

export default function Header() {
  const {
    searchQuery,
    setSearchQuery,
    searchResults,
    fetchProductsSearch,
  } = useFilter();

  const [showDropdown, setShowDropdown] = useState(false);
  const debounceTimeout = useRef(null);
  const suppressRef = useRef(false);

  const router = useRouter();

  const handleInputChange = (value) => {
    suppressRef.current = false; // allow search

    if (debounceTimeout.current) clearTimeout(debounceTimeout.current);

    debounceTimeout.current = setTimeout(() => {
      setSearchQuery(value);
    }, 300);
  };

  // Show dropdown when results are ready
  useEffect(() => {
    if (suppressRef.current) return;

    if (searchQuery.trim() && searchResults.length > 0) {
      setShowDropdown(true);
    } else {
      setShowDropdown(false);
    }
  }, [searchQuery, searchResults]);

  const handleManualSearch = async () => {
    if (!searchQuery.trim()) return;

    suppressRef.current = true;
    setShowDropdown(false);

    // manually trigger search API
    await fetchProductsSearch(searchQuery);

    router.push(
      `/products/filter-products?title=${encodeURIComponent(searchQuery)}`
    );
  };

  const handleSuggestionClick = async (p) => {
    suppressRef.current = true; // prevent search API refetch

    setSearchQuery(p.title);

    router.push(
      `/products/filter-products?title=${encodeURIComponent(
        p.title
      )}&brand=${encodeURIComponent(p.spec?.brand || "")}`
    );

    setShowDropdown(false);
  };

  return (
    <div
      className="w-full z-40 shadow-md sticky top-0 flex flex-col xl:flex-row h-auto justify-between items-center px-4 xl:px-8 py-4 gap-3"
      style={{ backgroundColor: colors.primary }}
    >
      {/* Logo */}
      <div className="w-full flex justify-between items-center xl:w-auto">
        <Link href="/">
          <Image
            src={Logo}
            alt="logo"
            width={100}
            height={100}
            className="w-[140px] md:w-[180px] h-[45px] object-contain"
          />
        </Link>
      </div>

      {/* Search bar */}
      <div className="relative w-full xl:w-[800px]">
        <input
          type="search"
          defaultValue={searchQuery}
          onChange={(e) => handleInputChange(e.target.value)}
          placeholder="Search Products, Brands and more"
          className="w-full outline-none bg-[#f9f6f6] text-black  h-[45px] rounded pl-3 pr-10"
        />

        <div
          className="absolute px-2 py-2 right-0 rounded-tr rounded-br top-0 bottom-0 bg-gray-300 cursor-pointer"
          onClick={handleManualSearch}
        >
          <IoMdSearch size={20} className="text-black" />
        </div>

        {showDropdown && searchResults.length > 0 && (
          <div className="absolute w-full bg-white border mt-1 rounded shadow-md max-h-64 overflow-y-auto z-50">
            {searchResults.map((p) => (
              <div
                key={p._id}
                className="px-3 py-2 hover:bg-gray-100 cursor-pointer"
                onClick={() => handleSuggestionClick(p)}
              >
                <p className="font-semibold">{p.title}</p>
                <p className="text-sm text-gray-600">
                  {p.spec?.brand || "Unknown Brand"} — {p.model}
                </p>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Phone Button */}
      <div className="hidden xl:block">
        <button className="flex items-center gap-2 rounded h-[40px] px-5 text-base bg-white">
          <FaPhoneAlt style={{ color: colors.primary }} size={18} />
          <span className="text-[#171717]">+91-96688906624</span>
        </button>
      </div>
    </div>
  );
}
